import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=f0667c40&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=f0667c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0667c40",
  null
  
)

export default component.exports